import React, { FC } from 'react';

import PageHeader from '../../components/page-header/page-header';
import ErrorPage from '../../components/common/error-page';
import ErrorContextProvider from '../../contexts/graphql-errors-context';
import { ViewLarge, Viewport, ViewSmall } from '@shared-ui/viewport-context';
import HomePageMobileLayout from '../../components/layout/home-page-mobile-layout';
import MobileSidebar from '../../components/sidebar/mobile-sidebar';
import HomePageLayout from '../../components/layout/home-page-layout';
import Sidebar from '../../components/sidebar/sidebar';
import useNavigationParams from '../../hooks/useNavigationParams';
import MarketingPageLayout from '../../components/layout/marketing-page-layout';
import DocumentView from '../../components/document-view/document-view';
import { DevhubMarketingPage } from '../../marketing-pages/devhub';
import useGraphqlErrors from '../../hooks/useGraphqlErrors';
import useSideBarVisibility from '../../hooks/useSideBarVisiblity';
import SideBarVisibilityContextProvider from '../../contexts/sidebar-visibility-context';
import MessageBannerContextProvider from 'contexts/message-banner-context';
import HeaderTitle from '../../components/header-title';
import HomeDocumentView from '../../components/document-view/home-document-view';

const HomeContent: FC = () => (
  <ErrorContextProvider>
    <MessageBannerContextProvider>
      <SideBarVisibilityContextProvider>
        <HomePage />
      </SideBarVisibilityContextProvider>
    </MessageBannerContextProvider>
  </ErrorContextProvider>
);

const HomePage: FC = () => {
  const { hasError } = useGraphqlErrors();
  const { hubId, tabId } = useNavigationParams();
  const { hideSideBar } = useSideBarVisibility();
  if (hasError) {
    return <ErrorPage />;
  }

  if (!tabId) {
    return hubId.startsWith('docs') || hubId.startsWith('mock') ? (
      <React.Fragment>
        <MarketingPageLayout header={<PageHeader />} body={<DevhubMarketingPage hubId={hubId} />} />
        <HeaderTitle />
      </React.Fragment>
    ) : (
      <Viewport>
        <ViewSmall>
          <HomePageMobileLayout header={<PageHeader />} sidebar={null} document={<HomeDocumentView />} />
        </ViewSmall>
        <ViewLarge>
          <HomePageLayout hideSideBar header={<PageHeader />} sidebar={null} document={<HomeDocumentView />} />
        </ViewLarge>
      </Viewport>
    );
  }

  return (
    <Viewport>
      <ViewSmall>
        <HomePageMobileLayout
          header={<PageHeader />}
          sidebar={<MobileSidebar hideSideBar={hideSideBar} />}
          document={<DocumentView />}
        />
      </ViewSmall>
      <ViewLarge>
        <HomePageLayout
          hideSideBar={hideSideBar}
          header={<PageHeader />}
          sidebar={<Sidebar />}
          document={<DocumentView />}
        />
      </ViewLarge>
    </Viewport>
  );
};

export default HomeContent;
